export const dataHooks = {
  swatch: 'color-swatches-swatch',
  empty: 'color-swatches-empty',
  emptyTooltip: 'color-swatches-empty-tooltip',
  addButton: 'color-swatches-add-button',
  addButtonPopover: 'color-swatches-add-button-popover',
  addButtonColorPicker: 'color-swatches-add-button-colorpicker',
};
